import { useContext, useEffect } from "react";
import Context from "../../../context";
import Button from "../Input/Button";
import * as Icon from "react-bootstrap-icons";
import { useHistory } from "react-router";
import dayjs from "dayjs";
import axios from "axios";
import { API_URL } from "../../data/constants";

function AccountDetailActionCard({
  cardTitle,
  children,
  buttonText,
  alignStart,
  onClick,
}) {
  return (
    <div className="col-lg-4 col-md-12 col-sm-12">
      <div className="account-card">
        <div className="account-card-body">
          <h2 className="account-card-title">{cardTitle}</h2>
          <div
            className={`account-card-wrapper${
              alignStart ? "--align-start" : ""
            }`}>
            {children}
          </div>
          <div className="form-section--button account-card-button">
            <Button
              onClick={onClick}
              className="btn btn--green btn--bordered"
              text={buttonText}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function AccountDueDetail({ account }) {
  const history = useHistory();
  const { contextState, setContextState } = useContext(Context);
  return (
    <div className={`account-detail-due-detail--${account?.status}`}>
      <div className="account-detail-due-detail--wrapper">
        {account?.status === "DueSoon" && (
          <h2 className="account-detail-header">
            <Icon.ExclamationTriangleFill /> Due soon
          </h2>
        )}
        {(account?.status === "Due" || account?.status === "Paid" || account?.status === "") && (
          <h2 className="account-detail-header">Current Amount Due</h2>
        )}
        {account?.status === "ShutOff" && (
          <h2 className="account-detail-header">
            <Icon.ExclamationTriangleFill /> Scheduled for Shut Off
            {account?.shutoffScheduledDate && (
                <div>On {dayjs(account?.shutoffScheduledDate).format("MMM D, YYYY")}</div>
            )}
          </h2>
        )}

        {account?.status === "PastDue" && (
          <h2 className="account-detail-header">
            <Icon.ExclamationTriangleFill /> Past Due Amount
          </h2>
        )}
        <div className="account-detail-due-detail-detail">
          <p className="display-1">${account?.invoice?.isPaid || account?.invoice === null ? 0 : account?.invoice?.balanceRemaining.toFixed(2)}</p>
          {account?.status !== "ShutOff" && account?.status !== "Paid" && account?.status !== "" && (
            <h4 className="account-detail-due-info">
              Due {dayjs(account?.dueDate).format("MMM D, YYYY")}
            </h4>
          )}
          {account?.status === "ShutOff" && (
            <h4 className="account-detail-due-info">
              This account will be shut off soon for non-payment.
            </h4>
          )}
        </div>
        <Button
          className="btn btn--green btn--bordered"
          onClick={() => {
            history.push(
              `/account/${contextState.currentAccountId}/pay-my-bill`
            );
          }}
          text="Pay My Bill"
        />
      </div>
    </div>
  );
}

function ChecklistItem({ itemHeader, children, isEnabled }) {
  return (
    <div className="checklist-item">
      {isEnabled ? (
        <Icon.Check2Circle
          className="checklist-icon"
          color={"#67BD45"}
          height={24}
          width={24}
        />
      ) : (
        <Icon.X
          className="checklist-icon"
          width={24}
          height={24}
          color={"#f32d2d"}
        />
      )}
      <div className="checklist-text">
        <h4 className="checklist-header">{itemHeader}</h4>
        {children && children}
      </div>
    </div>
  );
}

export default function AccountDetailPage() {
  const { contextState, setContextState } = useContext(Context);

  let account = contextState.currentAccount;
  let userRole = localStorage.getItem("userRole");
  const history = useHistory();

  useEffect(() => {}, [contextState.currentAccount]);

  return (
    <div className="individual-wrapper">
      <div className="account-detail-wrapper">
        <div className="account-detail-account-container">
          <div className="account-detail-account">
            <h1 className="account-detail-cardTitle">
              {account?.customerName}
            </h1>
            <h6 className="customer-id">Customer #: {account?.customerNumber}</h6>
            <p className="address-line1">
              {account?.customerAddress}
              {account?.address1}
            </p>
            <div className="address-details">
              <p className="address-line2">{account?.address2}</p>
              <p className="address-csz">{account?.cityStateZip}</p>
            </div>
          </div>
          <Button
            className="btn btn--green btn--bordered mb-4"
            onClick={() => {
              setContextState({ ...contextState, detailActivePage: "add" });
            }}
            text="Add or Link Account"
          />
        </div>
        <div className="account-detail-payment-detail">
          <AccountDueDetail account={account} />
          {userRole !== "IT-User" && (
          <div className="row">
            <AccountDetailActionCard
              cardTitle="Last Payment"
              onClick={() => {
                history.push(
                  `/account/${contextState.currentAccountId}/payment-history`
                );
              }}
              buttonText="View Previous Bill">
              <div className="last-payment">
                <Icon.Check2Circle height={24} width={24} color={"#67BD45"} />
                <div className="payment-info">
                  <h4 className="amount">
                    ${account?.payment?.totalAmount.toFixed(2)}
                  </h4>
                  {account?.status !== "" && (
                      <p className="received font-italic">
                        Received on{" "}
                        {dayjs(account?.payment?.createdOn).format("MMM D, YYYY")}
                      </p>
                  )}
                </div>
              </div>
            </AccountDetailActionCard>
            <AccountDetailActionCard
              cardTitle="Rate Plan Info"
              onClick={() => {
                setContextState({ ...contextState, detailActivePage: "renew" });
              }}
              buttonText="Renew Rate Plan">
              <h5>{account?.contractRateType}</h5>
              {account?.contractRate && account?.ratePlanChosen && (
                  <h4>${account?.contractRate} per therm</h4>
              )}
              {account?.ratePlanChosen && (
                <p className="font-italic">
                  {dayjs(account?.contractStartDate).format("MM/DD/YYYY")} -{" "}
                  {dayjs(account?.contractEndDate).format("MM/DD/YYYY")}
                </p>
              )}
            </AccountDetailActionCard>
            <AccountDetailActionCard
              cardTitle="Checklist"
              onClick={() => {
                history.push(
                  `/account/${contextState.currentAccountId}/pay-my-bill`
                );
              }}
              alignStart={true}
              buttonText="Pay My Bill">
              <ChecklistItem
                isEnabled={account?.paperless}
                itemHeader="Paperless">
                {account?.paperless === false && (
                  <div className="link-container">
                    <span
                      className="checklist-link"
                      onClick={() => {
                        axios
                          .post(API_URL + "/Accounts", {
                            customerId: account.contract.customerId,
                            customerNumber: account.customerNumber,
                            masterCustomerId: null,
                            paperless: true,
                          })
                          .then((res) => {
                            const payload = {
                              ...contextState.currentAccount,
                              paperless: true,
                            };
                            setContextState((prevState) => ({
                              ...prevState,
                              currentAccount: payload,
                            }));
                          });
                      }}>
                      Turn On
                    </span>
                  </div>
                )}
              </ChecklistItem>
              <ChecklistItem
                itemHeader="Autopay"
                isEnabled={account?.autoPay}
              />
              <ChecklistItem
                itemHeader="Rate Plan Chosen"
                isEnabled={account?.ratePlanChosen}>
              </ChecklistItem>
            </AccountDetailActionCard>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
